
<template>
  <!--投诉管理-->
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="chat_complaint_id"
      :rowOptLen="4"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-tooltip :title="row.object_desc">
          <div class="appeal-txt">{{row.object_desc}}</div>
        </a-tooltip>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import fetchSelect from '../../utils/mixins/fetchSelect.js';
export default {
  mixins: [fetchSelect],
  name: 'appeal',
  props: {
    tabType: {
      default: () => '1'
    }
  },
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '投诉人、昵称', options: [], inputType: 'input' },
        { props: ['chat_category_id'], placeholder: '投诉原因', options: [], inputType: 'cascader' },
        { props: ['status'], placeholder: '状态', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['投诉时间', '投诉时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: undefined,
        chat_category_id: undefined,
        status: undefined,
        create_date: undefined
      },
      tableOptList: [],
      rowOptList: [
        {
          text: '处理',
          handle: record => this.handleComplain(record, '处理'),
          rowOptDisHandle: record => this.optBtnDisable(record, '处理'),
          permi: ['neighbour:complain:handle']
        },
        {
          text: '撤销',
          handle: record => this.handleComplain(record, '撤销'),
          rowOptDisHandle: record => this.optBtnDisable(record, '撤销'),
          permi: ['neighbour:complain:cancel']
        }
      ],
      columns: [
        { title: '投诉人', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '投诉原因', dataIndex: 'chat_category_desc', align: 'left', width: '' },
        { title: '投诉用户', dataIndex: 'object_desc', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '投诉时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '处理时间', dataIndex: 'handle_time', align: 'left', width: '' },
        { title: '处理方式', dataIndex: 'handle', align: 'left', width: '' },
        { title: '群状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: `/chat/complaint/list/${this.tabType}`,
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.handleColumns();
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      /** 1.用户投诉 2.群聊投诉 3.动态投诉 */
      this._get({
        url: '/chat/complaint/selectlist',
        params: { type: this.tabType }
      }).then(({data}) => {
        this.searchList[1].options = data.category;
        this.searchList[2].options = data.status;
      });
    },
    /** 处理table列表 */
    handleColumns () {
      let columnType = {
        1: '投诉用户',
        2: '投诉群聊',
        3: '投诉动态',
        4: '投诉评论/回复'
      };
      this.columns[2].title = columnType[this.tabType];
    },
    optBtnDisable (record, type) {
      if (type === '处理' && record.status !== 0) {
        return true;
      } else if (type === '撤销' && record.is_can_cancel === 0) {
        return true;
      }
    },
    /** 处理投诉 */
    handleComplain (row, type) {
      if (type === '处理') {
        this.$router.push({
          name: 'handleComplain',
          query: {
            id: row.chat_complaint_id,
            type: this.tabType,
            title: '投诉处理',
            ...this.breadParam(this)
          }
        });
      } else if (type === '撤销') {
        this.$confirm({
          title: '确定要撤销处理吗？',
          centered: true,
          onOk: () => {
            this._post({
              url: '/chat/complaint/cancel',
              params: { chat_complaint_id: row.chat_complaint_id }
            }).then(({data}) => {
              this.$message.success('撤销成功');
              this.$refs.table.getTableList();
            });
          }
        });
      }
    },
    /** 进入已禁言用户 */
    toBanned (record) {
      this.$router.push({
        name: 'banned',
        query: { id: '' }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  },
  filters: {
    handleStatus (row) {
      // 0.未处理 1.已处理 2.处理撤销 3.处理结束
      if (row.status === 0) {
        return '处理';
      } else if (row.status === 1) {
        return '撤销';
      } else if (row.status === 2 || row.status === 3) {
        return '';
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../style/variable";
.appeal-txt {
  @include over-txt(200px);
}
</style>
